/**
 * Planilha paginada (spec 058): o rascunho de cada linha fica guardado ao trocar de pagina. Quando ha linha alterada sem
 * salvar em outra pagina, avisa e leva ate ela, pra ninguem esquecer de salvar.
 */
import { Aviso, POR_PAGINA } from "@mtc/ui";

export function ForaDaPagina<L>({ linhas, alteradas, nome, pagina, aoIr }: { linhas: L[]; alteradas: (l: L) => boolean; nome: (l: L) => string; pagina: number; aoIr: (p: number) => void }) {
  const fora = linhas.map((l, i) => ({ l, p: Math.floor(i / POR_PAGINA) + 1 })).filter((x) => alteradas(x.l) && x.p !== pagina);
  if (!fora.length) return null;
  return (
    <Aviso tipo="alerta">
      {fora.length === 1 ? "1 linha alterada sem salvar em outra página:" : `${fora.length} linhas alteradas sem salvar em outras páginas:`}{" "}
      {fora.map((x, i) => (
        <span key={i}>
          {i > 0 && ", "}
          <button type="button" className="mtc-link" style={{ background: "none", border: 0, padding: 0, cursor: "pointer", font: "inherit" }} onClick={() => aoIr(x.p)}>{nome(x.l)} (página {x.p})</button>
        </span>
      ))}
      .
    </Aviso>
  );
}
